"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.assetLoaded = assetLoaded;
exports.assetLoading = assetLoading;
exports.discardDraft = void 0;
exports.fetchPortalSuccess = fetchPortalSuccess;
exports.getPortal = getPortal;
exports.orderPages = orderPages;
exports.pageLoaded = pageLoaded;
exports.pageLoading = pageLoading;
exports.portalLoaded = portalLoaded;
exports.portalLoading = portalLoading;
exports.publishAsset = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _exchangeApiClient = require("@mulesoft/exchange-api-client");
var _actionify = _interopRequireDefault(require("../../utils/actionify"));
var _analytics = require("../../utils/analytics");
var _errors = require("../../utils/errors");
var sessionSelectors = _interopRequireWildcard(require("../session/selectors"));
var actions = _interopRequireWildcard(require("./actionTypes"));
var events = _interopRequireWildcard(require("./events"));
var selectors = _interopRequireWildcard(require("./selectors"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/** Publishes the draft of a portal documentation so it can be available for viewers */
var publishAsset = exports.publishAsset = (0, _actionify.default)(_exchangeApiClient.PortalService, function (service) {
  return service.publish;
}, actions.PUBLISH_PORTAL, {
  successProps: function successProps(params) {
    return (0, _analytics.clientTrackPayload)({
      eventSchema: events.DRAFT_PUBLISHED,
      properties: events.draftPublishedProperties(params)
    });
  }
});
function assetLoading() {
  return {
    type: actions.ASSET_LOADING
  };
}
function assetLoaded() {
  return {
    type: actions.ASSET_LOADED
  };
}
function fetchPortalSuccess(_ref) {
  var groupId = _ref.groupId,
    assetId = _ref.assetId,
    version = _ref.version,
    data = _ref.data,
    isDraft = _ref.isDraft;
  return {
    type: actions.FETCH_PORTAL_SUCCESS,
    data: data,
    groupId: groupId,
    assetId: assetId,
    isDraft: isDraft,
    version: version
  };
}
function portalLoading() {
  return {
    type: actions.PORTAL_LOADING
  };
}
function portalLoaded() {
  return {
    type: actions.PORTAL_LOADED
  };
}
function pageLoading() {
  return {
    type: actions.PAGE_LOADING
  };
}
function pageLoaded() {
  return {
    type: actions.PAGE_LOADED
  };
}

/** Gets portal metadata */
function getPortal(_ref2) {
  var groupId = _ref2.groupId,
    assetId = _ref2.assetId,
    version = _ref2.version,
    _ref2$isDraft = _ref2.isDraft,
    isDraft = _ref2$isDraft === void 0 ? false : _ref2$isDraft;
  return /*#__PURE__*/function () {
    var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(dispatch, getState, _ref3) {
      var config, state, portal, context, portalService, _yield$portalService$, portalContent, pagesOrderRevision;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            config = _ref3.config;
            state = getState();
            portal = selectors.portal(state, {
              groupId: groupId,
              assetId: assetId,
              version: version,
              isDraft: isDraft
            });
            context = sessionSelectors.context(state);
            portalService = new _exchangeApiClient.PortalService(config);
            if (!(portal && portal.pages)) {
              _context.next = 7;
              break;
            }
            return _context.abrupt("return", Promise.resolve(portal));
          case 7:
            dispatch(portalLoading());
            _context.next = 10;
            return portalService.get({
              groupId: groupId,
              assetId: assetId,
              version: version,
              context: context,
              isDraft: isDraft
            });
          case 10:
            _yield$portalService$ = _context.sent;
            portalContent = _yield$portalService$.portalContent;
            pagesOrderRevision = _yield$portalService$.pagesOrderRevision;
            dispatch(fetchPortalSuccess({
              data: _objectSpread(_objectSpread({}, portalContent), {}, {
                pagesOrderRevision: pagesOrderRevision
              }),
              groupId: groupId,
              assetId: assetId,
              isDraft: isDraft,
              version: version
            }));
            dispatch(portalLoaded());
            return _context.abrupt("return", portalContent);
          case 16:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x, _x2, _x3) {
      return _ref4.apply(this, arguments);
    };
  }();
}

/** Changes the order of asset portal pages */
function orderPages(_ref5) {
  var groupId = _ref5.groupId,
    assetId = _ref5.assetId,
    version = _ref5.version,
    pages = _ref5.pages,
    isDraft = _ref5.isDraft;
  return function (dispatch, getState, options) {
    var state = getState();
    var portal = selectors.portal(state, {
      groupId: groupId,
      assetId: assetId,
      version: version,
      isDraft: isDraft
    });
    var currentPagesOrderRevision = portal.pagesOrderRevision;
    var currentPages = portal.pages;
    var pageRequest = {
      groupId: groupId,
      assetId: assetId,
      version: version,
      pages: pages,
      pagesOrderRevision: currentPagesOrderRevision,
      currentPages: currentPages,
      isDraft: isDraft
    };
    return (0, _actionify.default)(_exchangeApiClient.PageService, function (service) {
      return function (params) {
        return service.orderPages(_objectSpread(_objectSpread({}, params), {}, {
          pages: params.pages.map(function (page) {
            return page.title;
          })
        }));
      };
    }, actions.ORDER_PAGES)(pageRequest)(dispatch, getState, options).catch(function (error) {
      var reorderingConflictError = new _errors.HTMLError('There was an error while saving the order of the pages. The file have been modified by another user. Try <a onclick="window.location.reload()">refreshing the page</a>.');
      reorderingConflictError.requestId = error.requestId;
      if (error.status === 409) {
        throw reorderingConflictError;
      } else {
        throw error;
      }
    });
  };
}

/** Discards the current draft changes for the asset portal documentation */
var discardDraft = exports.discardDraft = (0, _actionify.default)(_exchangeApiClient.PortalService, function (service) {
  return service.deleteDraft;
}, actions.DISCARD_PORTAL_DRAFT);
//# sourceMappingURL=actions.js.map